import styled from "styled-components";

export const LinkModalFields = styled.div`
  display: flex;
  flex-direction: column;
`;
